<template>
  <b-card title="Paket Limitleri">
    <template v-if="itemData.package_limits.length > 0">
      <template v-for="(item,key) in itemData.package_limits">
        <b-row
          :key="key"
          class="d-flex justify-content-center align-items-center"
        >
          <b-col
            cols="12"
            md="9"
          >
            <h6 class="text-dark">
              {{ item.title }}
            </h6>
          </b-col>
          <b-col
            cols="12"
            md="3"
          >
            <limit-value-card :i-key="key" />
          </b-col>
        </b-row>
        <hr>
      </template>
    </template>
    <b-alert
      v-else
      class="m-2"
      variant="primary"
      show
    >
      <div class="alert-body text-center">
        <FeatherIcon icon="InfoIcon" />
        <div>
          Kayıtlı veri bulunmuyor.
        </div>
        <div>
          <small>Limitleri görüntülemek için proje seçiniz.</small>
        </div>
      </div>
    </b-alert>
  </b-card>
</template>
<script>
import {
  BCard, BRow, BCol, BAlert,
} from 'bootstrap-vue'
import LimitValueCard from '@/views/Admin/Project_packages/PackageLimits/ValueCard.vue'

export default {
  name: 'ProjectPackagesLimitForm',
  components: {
    LimitValueCard,
    BAlert,
    BCard,
    BRow,
    BCol,
  },
  computed: {
    itemData() {
      return this.$store.getters['projectPackages/dataItem']
    },
  },
}
</script>
